import { ErrorMessages } from "../../../../enums";
import { ErrorHandlingModeType } from "../../../Configurator/Types/ConfiguratorTypes";
import { ErrorCodes } from "../../../Exception/ErrorCodes";
import { ErrorStatuses } from "../../../Exception/ErrorStatuses";
import BaseValidator from "../../../Global/Validator/BaseValidator";
import { EventGameOutcomeTypeEnum } from "../Models/EventGameFixturesModel";
import EventGamePredictionRequestBody from "../Models/Prediction/RequestBody/EventGamePredictionRequestBody";

export default class EventGameValidator extends BaseValidator {
  constructor(errorHandlingMode: ErrorHandlingModeType) {
    super(errorHandlingMode);
  }

  public validatePrediction = (prediction: EventGamePredictionRequestBody) => {
    if (
      !prediction.fixtures ||
      !Array.isArray(prediction.fixtures) ||
      prediction.fixtures.length === 0
    ) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_METHOD_CALL,
        ErrorMessages.REQUIRED_FIXTURES_FIELD
      );
    }

    const validKeys = ["id", "predictionType", "prediction"];

    for (const f of prediction.fixtures) {
      if (
        Object.keys(f).length !== validKeys.length ||
        Object.keys(f).some((key) => !validKeys.includes(key))
      ) {
        this.throwException(
          ErrorCodes.BAD_METHOD_CALL,
          ErrorStatuses.INVALID_METHOD_CALL,
          ErrorMessages.INVALID_FIXTURES_FIELD
        );
      }

      this.validatePredictionType(f.predictionType, f.prediction);
    }

    if (
      prediction.tiebreaker &&
      (!prediction.tiebreaker.statTotal ||
        !Number.isInteger(prediction.tiebreaker.statTotal))
    ) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_METHOD_CALL,
        ErrorMessages.INVALID_TIEBREAKER_FIELD
      );
    }
  };

  private validatePredictionType = (
    predictionType: EventGameOutcomeTypeEnum,
    prediction: string | number | boolean
  ) => {
    switch (predictionType) {
      case EventGameOutcomeTypeEnum.BOOLEAN:
        if (typeof prediction !== "boolean") {
          this.throwException(
            ErrorCodes.BAD_METHOD_CALL,
            ErrorStatuses.INVALID_METHOD_CALL,
            `Prediction must be a boolean for prediction type ${predictionType}`
          );
        }
        break;

      case EventGameOutcomeTypeEnum.NUMBER:
        if (typeof prediction !== "number" || !Number.isFinite(prediction)) {
          this.throwException(
            ErrorCodes.BAD_METHOD_CALL,
            ErrorStatuses.INVALID_METHOD_CALL,
            `Prediction must be a number for prediction type ${predictionType}`
          );
        }
        break;

      case EventGameOutcomeTypeEnum.ENUM:
      case EventGameOutcomeTypeEnum.FREE_INPUT:
        if (typeof prediction !== "string" || prediction.trim() === "") {
          this.throwException(
            ErrorCodes.BAD_METHOD_CALL,
            ErrorStatuses.INVALID_METHOD_CALL,
            `Prediction must be a non-empty string for prediction type ${predictionType}`
          );
        }
        break;

      default:
        this.throwException(
          ErrorCodes.BAD_METHOD_CALL,
          ErrorStatuses.INVALID_METHOD_CALL,
          `Unknown prediction type: ${predictionType}`
        );
    }
  };
}
